import { render, staticRenderFns } from "./SyncNotification.vue?vue&type=template&id=b94d7a1e&scoped=true&"
import script from "./SyncNotification.vue?vue&type=script&lang=js&"
export * from "./SyncNotification.vue?vue&type=script&lang=js&"
import style0 from "./SyncNotification.vue?vue&type=style&index=0&id=b94d7a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94d7a1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
